import GET from "./api/GET";
import POST from "./api/POST";
import PUT from "./api/PUT";
import DELETE from "./api/DELETE";

export const fetchWebhooks = async (
  page = 1,
  limit = process.env.REACT_APP_PAGINATION_LIMIT || 10,
  search
) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;

  const response = await GET(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/webhook/get?branchId=${branchId}&page=${page}&limit=${limit}&search=${search}`
  );
  return response;
};

export const createNewWebhook = async (credentials) => {
  const currentBranchData = localStorage.getItem(
    "wow-delivery-kw-merchant-current-branch"
  );
  const branchId = JSON.parse(currentBranchData)?._id;

  const response = await POST(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/webhook/create`,
    { ...credentials, branchId: branchId }
  );
  return response;
};

export const editWebhook = async (credentials) => {
  const response = await PUT(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/webhook/update/${credentials?._id}`,
    { ...credentials }
  );
  return response;
};

export const deleteWebhook = async (credentials) => {
  const response = await DELETE(
    `${process.env.REACT_APP_API_ENDPOINT}merchant/webhook/delete/${credentials?._id}`
  );
  return response;
};
